<template>
    <rkm-overlay>
        <rkm-layout-body
            title="Alteração de consultas finalizadas"
        >
            <template v-slot:actions>
                <rkm-button
                    color="danger"
                    @click="handleExit"
                >
                    Sair
                </rkm-button>
    
                <rkm-button
                    color="primary"
                    @click="handleSave"
                >
                    Salvar
                </rkm-button>
            </template>
        </rkm-layout-body>

         <rkm-layout-content>
             <List
                ref="List"
             />
         </rkm-layout-content>
    </rkm-overlay>
</template>

<script>
import List from '@/components/ambulatorio/alteracao-consultas-finalizadas/List'
import { mapActions } from 'vuex';

export default {
    components: {List},
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation'
        ]),
        handleExit(){
            this.$router.push({ name: 'dashboard' })
        },
        handleSave(){
            this.$refs.List.save()
        }
    }
}
</script>